<template>
  <div>
    <navbar></navbar>

    <div class="bg-header-straight-big">
      <div class="container">
        <div v-if="shop" >
        <h1>{{ shop.name }}</h1>
        <p class="subheader">Location - <span :class="shop.is_online ? 'open' : 'closed'"> {{ shop.is_online ? 'Geöffnet' : 'Geschlossen' }} </span></p>
        <button v-if="shop.is_online" @click.prevent="buyLive()" class="btn icon bg-green sized">
          <span><icon class="icon" name="shopping-cart"></icon></span>
          <span>Jetzt live einkaufen</span>
        </button>
       </div>
        <one-page-menu :sections="menuSections" ></one-page-menu>
      </div>
    </div>
 </div>
</template>

<script>
  import Navbar from '../Navbar.vue'
  import OnePageMenu from '../menus/onePageMenu'
  import {EventBus} from '@/assets/js/event-bus.js'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: 'cgShopHeader',
    components: {
      OnePageMenu,
      Navbar
    },
    props: {
      menuSections: {
        type: Object,
        default: function () {
          return {empty: true}
        }
      }
    },
    data () {
      return {
        buyLiveToast: null
      }
    },
    methods: {
      buyLive () {
        if (this.isAuthenticated) {
          if (!this.buyLiveToast) {
            this.buyLiveToast = this.$toasted.info('Wird gespeichert...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
            var self = this
            this.getInLine({
              shop: self.shop.uid,
              cb () {
                self.$toasted.success('Du stehst jetzt bei ' + self.shop.name, {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.x = null
              },
              errorCb () {
                self.$toasted.error('Einen Fehler ist aufgetreten, bitte versuch es nochmal oder kontaktiere unser Team', {
                  theme: 'primary',
                  position: 'top-right',
                  duration: 10000,
                  action: {
                    text: 'X',
                    class: 'toastBtn',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                  icon: 'check'
                })
                self.buyLiveToast.goAway(100)
                self.buyLiveToast = null
              }
            })
          }
        } else {
          EventBus.$emit('toggleLoginModal')
        }
      },
      ...mapActions([
        'getInLine'
      ])
    },
    computed: {
      ...mapGetters({
        shop: 'shop_get_details',
        isAuthenticated: 'auth_is_authenticated'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shop/CgShopHeader.vue